// This function allow to reference async chunks and sibling chunks for the entrypoint
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 1133) return "static/chunks/1133.f8b97913fe17fedf.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "-" + {"2437":"e593b76ce10967df","6485":"9cb393c22b77e1a9"}[chunkId] + ".js";
};